import React from "react";
import {App} from "./app/App";
import "./app/i18n";

import "./index.css";
import {createRoot} from "react-dom/client";
import {Demo} from "./demo/Demo";
import {QuizProvider} from "./quiz/quizContext";

const roots = {}

window.kitQuiz = {
    renderDemo: args => {
        const container = document.getElementById(args.containerId)
        const root = createRoot(container)
        root.render(
            <Demo {...args} />
        )
    },
    renderQuiz: args => {
        const {data, onSuccess, onClose} = args
        const container = document.getElementById(args.containerId)
        if(!roots[args.containerId]) {
            roots[args.containerId] = createRoot(container)
        }

        roots[args.containerId].render(
            <QuizProvider
                quiz={data.quiz}
                onSuccess={onSuccess}
                onClose={onClose}
            >
                <App
                    startIndex={data.startIndex}
                />
            </QuizProvider>
        )
    },

    unmountQuiz: containerId => {
        if(roots[containerId]) {
            roots[containerId].unmount()
            roots[containerId] = null
        }

    }
};

// reportWebVitals();


